import mappings from './mappings';

const createElementFromHTML = htmlString => {
    const node = document.createRange().createContextualFragment(htmlString.trim());
    document.body.appendChild(node);
    return;
};

const trackings = (trackingType, state, widgetId) => {
    const associatedMappings = mappings.find(
        mapping => mapping.widgetIds.includes(!state ? widgetId : state.widget.widgetId)
    );

    if (associatedMappings === undefined) return [];

    const widgetHasTrackingType = Object.keys(associatedMappings.trackings).includes(
        trackingType
    );

    if (widgetHasTrackingType) {
        return associatedMappings.trackings[trackingType].map(tracking => {
            if (typeof tracking === 'function'){
                if (tracking.length === 2 && associatedMappings.useEverytownTracking) {
                    const externalSiteId = encodeURIComponent(state.widget.articleUrlTracking);
                    const externalPlacementId = encodeURIComponent(state.widget.widgetId);
                    return tracking(externalSiteId, externalPlacementId);
                }
                else return tracking();
            } else if (tracking.includes(`timestamp`)) {
                return tracking.replace(
                    new RegExp('timestamp', 'g'),
                    Math.random()
                        .toFixed(16)
                        .slice(2)
                        .toString()
                );
            } else {
                return tracking;
            }
        });
    } else {
        return [];
    }
};

export const getOnClickHref = widgetId => trackings('onClick', null, widgetId);

export const appendTrackingPixels = (trackingType, state, widgetId) =>
    trackings(trackingType, state, widgetId).forEach(tracking =>
        tracking && createElementFromHTML(tracking)
    );
